import { SinglePageData } from "@/types";
import React, { useState } from "react";

import Info from "./components/Info";

import blue from "@/assets/blue.svg";
import breadcrump from "@/assets/breadcrump.svg";
import gallery_colored from "@/assets/gallery-colored.svg";
import gallery_icon from "@/assets/gallery.svg";
import info_colored from "@/assets/info-colored.svg";
import info from "@/assets/info.svg";
import map_colored from "@/assets/map-colored.svg";
import map from "@/assets/map.svg";
import phone from "@/assets/phone.svg";

import Star from "@/components/Star";
import AppLayout from "@/layouts/AppLayout";
import SEO from "@/utils/SEO";
import TransLink from "@/utils/TransLink";
import { router, usePage } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import StyledSinglePage, { SinglePageOverlay } from "../Styles/StyledSinglePage";
import Gallery from "./components/Gallery";
// import Map from "./components/Map";
import Map from "@/components/Map"
import useGeolocation from "@/hooks/useGeolocation";
import { CATEGORY_COLORS } from "@/utils/constants";
import Share from "@/features/share/Share";

type GalleryItem = {
    image: string;
};

type BusinessType = {
    business: {
        data: SinglePageData;
    };
};

const Show: React.FC<BusinessType> = ({ business }) => {
    useGeolocation();
    const { data } = business;
    const { seo } = usePage().props;
    const [activeTab, setActiveTab] = useState<number>(0);
    const [gallery, setGallery] = useState<GalleryItem[]>();
    const [loading, setLoading] = useState<boolean>(false);
    const { t } = useTranslation(["common", "validation", "glossary"]);

    const tabs = [
        {
            id: 0,
            title: t("info", { ns: "glossary" }),
            content: <Info accomodation={business} />,
            icon: info,
            iconColored: info_colored,
        },
        {
            id: 1,
            title: "Gallery",
            content: <Gallery loading={loading} gallery={gallery} />,
            icon: gallery_icon,
            iconColored: gallery_colored,
        },
        {
            id: 2,
            title: t("map", { ns: "glossary" }),
            content: data.lng && data.lat && (
                <Map
                    coords={{
                        lng: data.lng,
                        lat: data.lat,
                    }}
                    color={CATEGORY_COLORS.businesses}
                />
            ),
            icon: map,
            iconColored: map_colored,
        },
    ];

    const onTabChange = (id: number) => {
        if (id === 1 && typeof gallery == "undefined") {
            router.reload({
                only: ["images"],
                onStart: () => {
                    setLoading(true);
                },
                onSuccess: (page) => {
                    if (page.props.images.length != 0) {
                        setGallery(page.props.images);
                    } else {
                        setGallery(null);
                    }
                },
                onFinish: () => {
                    setLoading(false);
                },
            });
        }
        setActiveTab(id);
    };

    return (
        <AppLayout>
            <SEO seo={seo} />
            {data && (
                <StyledSinglePage image={data.main_banner_image ?? ""}>
                    {data.seo && <SEO seo={data.seo} />}
                    <div className="bg-image h-[600px] bg-cover bg-center w-full flex justify-center items-center lg:items-end relative pb-20 ">
                        <SinglePageOverlay />

                        <div className="text-white container z-10 flex flex-row items-center justify-between flex-wrap px-2 gap-4 ">
                            <div>
                                <div className="text-3xl font-bold mb-4">
                                    {data.name}
                                </div>
                                <div className="flex flex-row items-center gap-4">
                                    <img src={blue} />
                                    <div className="text-base flex flex-row items-center gap-4">
                                        <TransLink
                                            url={
                                                "/search?isMapView=true&page=1&searchScope[0]=Business"
                                            }
                                        >
                                            {t("Business", {
                                                ns: "glossary",
                                            })}
                                        </TransLink>
                                        <img src={breadcrump} />{" "}
                                        <TransLink
                                            url={
                                                "/search?isMapView=true&page=1&searchScope[0]=Business&business_types[0]=" +
                                                data.types?.slug.key
                                            }
                                        >
                                            {data.types?.name}
                                        </TransLink>
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-row gap-4 h-9 flex-wrap">
                                <Share shareUrl={data.url || window.location.href} title={data.name || 'Visit Thassos'} />
                                <Star item={data} />
                                <a
                                    href={`tel:${data.mobile}`}
                                    className="border-2  px-3 rounded-md flex items-center justify-center gap-6 hover:bg-black/30 transition h-10"
                                >
                                    <img src={phone} className="w-6" />
                                    <div className="text-lg">{t("contact", { ns: "glossary" })}</div>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="container m-auto flex flex-col pb-20 max-lg:px-4">
                        <div className="text-center flex flex-wrap md:mt-0 mt-8  md:border md:border-primary justify-between md:justify-start  rounded-lg  self-center w-full md:w-auto md:bg-white bottom-6 relative space-x-2 lg:space-x-0.5 mb-5">
                            {tabs.map((tab) => (
                                <button
                                    title={tab.title}
                                    key={tab.id}
                                    onClick={() => onTabChange(tab.id)}
                                    className={`${activeTab === tab.id ? "bg-primary" : "  hover:bg-primary/20"} transition-all p-2 lg:p-3 lg:w-52 rounded-md `}
                                >
                                    <div
                                        className={`${activeTab === tab.id ? "text-white" : "text-black"} transition-all flex flex-row items-center justify-center gap-1 lg:gap-4 `}
                                    >
                                        <img
                                            src={
                                                activeTab === tab.id
                                                    ? tab.icon
                                                    : tab.iconColored
                                            }
                                            className="hidden md:inline-block"
                                        />
                                        {tab.title}
                                    </div>
                                </button>
                            ))}
                        </div>

                        <div className="md:px-2">{tabs[activeTab].content}</div>
                    </div>
                </StyledSinglePage>
            )}
        </AppLayout>
    );
};

export default Show;
